export default {
  title: {
    login: "%{school} - Connexion",
    registration: "%{school} - Inscription",
    subjects: "%{school} - Choix de la matière",
    subject: "%{school} - Matière",
    offer: "%{school} - Offre",
    home: "%{school} - Tableau de bord",
    dictionary: "%{school} - Dictionaire",
    events: "%{school} - Événements",
    news: "%{school} - Actualité",
    profile: "%{school} - Profil",
    learn: "%{school} - Apprentissage",
    pay: "%{school} - Paiement pour la matière",
    checkInSystem: "Êtes-vous déjà inscrit?",
    setPassword: "Saisissez le mot de passe",
    createAccount: "Créez un compte dans le système.",
  },
  authCheckEmail: {
    title: "Entrez votre adresse email",
    emailCaption: "Adresse email",
    continue: "Continuer",
    or: "ou",
  },
  authPassword: {
    title: "Connectez-vous à votre compte",
    inputCaption: "Mot de passe",
    placeholder: "Saisissez votre mot de passe",
    forgot: "Mot de passe oublié?",
    submit: "Se connecter",
  },
  authRegistration: {
    title: "Inscription",
    name: "Nom",
    phone: "Numéro de téléphone",
    password: "Créez un mot de passe",
    confirmPassword: "Confirmez votre mot de passe",
  },
  totalError: "Oups, quelque chose s'est mal passé !",
  subjectChangeError: "Impossible de changer de matière. Réessayez ou contactez votre école.",
  email: "Email",
  personalLink: "Lien personnel",
  login: "Identifiant",
  name: "Nom",
  firstLastName: "Nom et prénom",
  phone: "Téléphone",
  formatPhone: "Le numéro de téléphone est au format 998...", // todo for leader-online
  aboutMe: "À propos de moi",
  fullAge: "Votre âge (années complètes)",
  errorAge: "âge incorrect",
  notNumber: "Doit être un nombre",
  registration: "Inscription",
  password: "Mot de passe",
  currentPassword: "Mot de passe actuel",
  newPassword: "Nouveau mot de passe",
  confirmPassword: "Confirmez le mot de passe",
  confirmNewPassword: "Confirmez le nouveau mot de passe",
  forgotPassword: "Mot de passe oublié?",
  passwordsMatch: "Les mots de passe ne correspondent pas",
  resetPassword: "Mot de passe a bien été reinitialisé, vérifiez votre email pour plus de détails.",
  resetConfirm: "Voulez-vous réinitialiser votre mot de passe?",
  enter: "Se connecter",
  studentEnter: "Connexion étudiant",
  check: "Suivant",
  signInWithGoogle: "Se connecter avec Google",
  emailIsNotRegistered: "L'utilisateur avec cette adresse e-mail n'existe pas",
  logout: "SE DÉCONNECTER",
  online: "en ligne",
  offline: "hors ligne",
  cancel: "Annuler",
  yes: "Oui",
  no: "Non",
  course: "Cours",
  dictionary: "Dictionnaire",
  events: "Événements",
  news: "Actualités",
  words: "Mots",
  wordsAreHere: "Ces mots se trouvent ici:",
  allWords: "Tous les mots",
  phrases: "Phrases",
  videos: "Vidéos",
  exercises: "Exercices",
  theory: "Théorie",
  theoryAlt: "Résumé",
  theoryAdditionalFile: "Télécharger le fichier supplémentaire (%{filename})",
  topic: "Sujet",
  lesson: "Leçon",
  lessons: "Cours",
  profile: "Profil",
  orders: "Commandes",
  payment: "Paiements",
  leaderboard: "Classement",
  leaderboardPerDay: "Les leaders du jour",
  time: "Temps",
  points: "Points",
  myPoints: "Mes points pour l'ensemble de la période",
  coins: "Pièces",
  courses: "Mes cours",
  loading: "Chargement...",
  noTheory: "Aucune théorie disponible pour cette leçon",
  startTraining: "Commencer l'entraînement",
  chat: {
    // === chat list / dialog additions ===
    startDialogTitle: "Démarrer un chat",
    startDialogTooltip: "Commencer une nouvelle conversation",
    messages: "Messages",
    unreadOnly: "Non lu seulement",
    delete: "Supprimer",
    send: "Envoyer",
    sendHelper: "Ctrl+Entrée pour envoyer un message",
    close: "Fermer",
    profile: "Profil",
    lastActivity: "Dernière activité",
    status: "Statut",
    jobTitle: "Intitulé du poste",
    tabLabel: "Chat",
    lastOnline: {
      time: "Dernière connexion à %{date}",
      weekday: "Dernière connexion le %{date}",
      dayMonth: "Dernière connexion le %{date}",
      monthYear: "Dernière connexion en %{date}",
    },
    read: "Lire",
    errors: {
      wrongFormatting: "Le message contient un format incorrect",
    },
  },
  branches: "Thèmes",
  easy: "Facile",
  expert: "Expert",
  wordToLearn: "Réviser plus tard",
  iKnowWord: "Je le sais",
  videoVocabulary: "Lexique vidéo",
  markVideoWatched: "Marquer comme visionnée",
  videoWatched: "Visionnée",
  passed: "complété",
  unsupportedExercise: "Ce type d'exercice (%{type}) ne peut pas encore être pris en charge.",
  changeCourse: "Changer la matière",
  currentCourse: "Cours actuel:",
  allSubjects: "Tous les cours",
  all: "Tous",
  subject: "Matière",
  group: "Groupe",
  start: "Commencer",
  chooseSubject: "Choisissez une matière à étudier",
  hourValue: "%{value} h",
  completed: "Terminé",
  notCompleted: "Non terminé",
  paidBranch: "Cette section est payante. Veuillez l’acheter pour l’étudier.",
  buyBranch: "Acheter cette section pour %{price} %{currency}",
  paidSubject: "Cette matière est payante. Veuillez l’acheter pour l’étudier.",
  buySubject2: "Acheter cette matière pour  %{price} %{currency}",
  decksItemNotOpen: "Pour accéder a cette leçon, vous devez terminer la leçon précédente",
  decksItemNotPurchasedBranch: "Le sujet de cette leçon est bloqué",
  decksItemNotOpenLevel: "Passez le niveau précédent pour ouvrir cette leçon",
  decksItemNotOpenBranch: "Pour accéder à cette section, vous devez terminer la section précédente",
  deckAccessDenied: "Cette leçon n'est pas encore disponible pour vous",
  openOnDate: "S'ouvrira le %{date}",
  levelAccessIsDenied: "Ce niveau n’est pas accessible pour vous",
  youAreDeactivated: "Votre compte a été désactivé, veuillez contacter votre école",
  youAreDeactivatedShort: "Votre compte est désactivé",
  youAreHaveNotPaidOffers: "Vous avez des offres non payées",
  yourCertificates: "Vos certificats",
  emptyDeck: "Leçon est vide",
  nextDeck: "Leçon suivante",
  next: "Suivant",
  proceed: "Continuer",
  skip: "Passer",
  more: "Plus",
  exit: "Quitter",
  details: "Voir les détails",
  go: "Aller",
  profileEdit: "Modifier le profil utilisateur",
  userInfo: "Informations utilisateur",
  of: "de",
  back: "Retour",
  levelPackExist: "Vous avez déjà cet ensemble de niveaux",
  awaitingPayment: "En attente de paiement",
  bought: "Acheté",
  boughtUntilDate: "Acheté jusqu’au %{endDate}",
  availableUntilDate: "Disponible jusqu’au %{endDate}",
  showMore: "Afficher plus",
  hide: "Cacher",
  communication: "Contact avec l’école",
  askQuestion: "Poser une question",
  noDescription: "Description manquante",
  description: "Description:",
  onePerMonth: "S'abonner pour un mois",
  semiannually: "S'abonner pour six mois",
  onceAYear: "S'abonner pour un an",
  stopSubscribe: "Arrêter l’abonnement",
  enable: "Activer l’abonnement",
  expired: "Expiré",
  buySubject: "Acheter la matière",
  buyOffer: "Acheter",
  subscribeOffer: "S’abonner",
  firstPayment: "Premier paiement",
  accessDaysWarning: "%{smart_count} jour restant |||| %{smart_count} jours restants",
  accessDemoDaysWarning: "Démo: %{smart_count} jour restant |||| Démo: %{smart_count} jours restants",
  accessDemoButton: "Accès démo",
  closeButton: "Fermer",
  existOffer: "There is already an unpaid offer",
  loginInProcess: "Processus d'enregistrement...",
  done: "Réalisé:",
  Levels: {
    empty: "Aucun niveau n’est disponible dans ce cours pour le moment.",
    name: "Niveau:",
  },
  Decks: {
    scormPass: "S'inscrire à un cours",
    proceed: "Continuer",
    stayHere: "Rester ici",
  },
  Exercises: {
    tabTitle: "Exercises",
    skip: "Suivant",
    check: "Vérifier",
    examCheck: "Envoyer",
    typeAnswer: "Écrivez votre réponse",
    next: "Suivant",
    rightAnswerWas: "TLa bonne réponse était:",
    showRightAnswer: "Afficher la bonne réponse",
    rightAnswer: "Bonne réponse :",
    congratulation: "Félicitations!",
    congratText: "Vous avez terminé tous les exercices de cette leçon!",
    wrongAnswer: "Votre réponse est incorrecte",
    answerSaved: "Réponse sauvegardée",
    commentToAnswer: "Commentaire sur la réponse sélectionnée:",
    appendix: {
      pdf: {
        tooltipButton: "Matériel supplémentaire",
      },
    },
    type13: {
      title: "Remplissez les vides en choisissant des mots corrects dans la liste déroulante.",
    },
    type12: {
      title: "En savoir plus",
    },
    type11: {
      title: {
        select: "Choisissez la bonne réponse",
        keyboard: "Écrivez la bonne réponse",
      },
    },
    type9: {
      title: {
        select: "Remplissez les vides en choisissant des mots",
        keyboard: "Remplissez les vides",
      },
    },
    type8: {
      title: "Trouvez les correspondances",
    },
    type7: {
      title: {
        text: "Écrivez votre réponse",
        audio: "Donnez la réponse audio",
      },
      recordingIsNotSupported: "L'enregistrement audio n'est pas pris en charge par votre navigateur.",
      audioRecordingError: "Erreur d'enregistrement audio",
      inputLabel: "Message",
      addPhotoVideo: "Ajouter une photo/vidéo (max 5)",
      addPhoto: "Ajouter une photo (max 5)",
      cameraInitialization: "Initialisation...",
      change: "Modifier",
      codeToApprove: "Mot de passe",
      homework: {
        teacherData: {
          audio: "Commentaire audio de l'enseignant",
          audioComment: "Commentaire audio de l'enseignant",
        },
      },
      addFiles: "Ajouter des fichiers",
      limitsHelperText: "La longueur du texte doit être d'au moins %{count} lettres",
      photoRequired: "Joignez au moins une photo ou un fichier à votre réponse",
      photoViewerHint: "Vous pouvez zoomer sur l'image avec la molette de la souris",
    },
    type6: {
      title: "Dessinez un élément",
      checkButtonText: "Bien entendu!",
    },
    type3: {
      title: "Glissez-déposez les éléments dans l’ordre",
      hint: "Glissez les éléments ici depuis la zone ci-dessous",
    },
    type5: {
      title: "Sélectionnez les éléments<",
      hint: ">Sélectionnez les éléments corrects en bas de l’écran (cliquez pour sélectionner)",
    },
    type2: {
      title: "Choisissez l’élément manquant",
    },
  },
  Events: {
    headNotice: "L’heure de l’événement est affichée selon votre fuseau horaire",
    title: "Événements de la semaine",
    startTime: "Heure de début:",
    finishTime: "Heure de fin:",
    group: "Groupe",
    persons: "%{smart_count} personne |||| %{smart_count} personnes",
    leader: "Animateur",
    tag: "Catégorie",
    joinedCheckbox: "Avec inscription",
    joined: "Sélectionné:",
    interested: "Inscription",
    registered: "Inscrit(e)",
    enter: "S'inscrire",
    limitPopupInfo: "ous avez atteint la limite d’inscriptions",
    eventHasStarted: "L’événement a déjà commenc!",
    registrationNotice: "Inscription réussie! Le bouton pour entrer sera actif le %{date_and_time}. Après ce moment, vous ne pourrez plus annuler votre inscription.",
    registrationNoticeNoUrl: "Inscription réussie! Après %{date_and_time} vous ne pourrez plus annuler votre inscription.",
    cancelRegistration: "Êtes-vous sûr(e) de vouloir annuler votre inscription",
    calendarLink: "Ajouter l’événement à Google Agenda",
    status_planned: "Planifie",
    status_started: "Commence",
    status_completed_successfully: "Termine",
    status_last_minute_cancellation: "Annule de derniere minute",
    status_late_cancellation: "Annulation tardive",
    status_canceled: "Annule",
    status_moved: "Reporte",
  },
  statistic: {
    title: "Statistiques",
    points: "Points",
    phrases: "Phrases",
    missions: "Missions",
    words: "Mots",
    time: "Temps",
  },
  status: {
    wait_review: "EN ATTENTE DE VÉRIFICATION",
    on_review: "EN COURS DE VÉRIFICATION",
    approved: "CONFIRMÉ",
    not_approved: "REJETÉ",
    not_approved_allow_update: "REJETÉ (à refaire)",
    ai_reviewed: "Testé avec l'IA",
  },
  homeworks: {
    tabName: "Devoirs",
    todo: "À faire",
    done: "Faits",
    topic: "Sujet",
    lesson: "Leçon",
    onlyInMobileApp: "Disponible uniquement dans une application mobile",
    todoHomework: "EN COURS DE VÉRIFICATION",
    postToDoButton: "Envoyer",
    types: {
      homework_todo: "À faire",
      exercise: "Exercice",
    },
    waitAIReview: "Veuillez patienter, l'IA vérifie la réponse.",
    dontWait: "ne pas attendre",
    checkingHomework: "Je vérifie mes devoirs",
  },
  exam: {
    popupTitle: "Leçon avec examen",
    popupDescr1: "Ceci est une leçon avec un examen. Étudiez d'abord tous les matériaux supplémentaires, puis passez aux exercices.",
    popupDescr2: `Dès que vous accédez à l'onglet "Exercices", le compte à rebours commence.`,
    popupDescr3: 'Les onglets "Théorie" et "Vidéo" ne démarrent PAS le compte à rebours de l\'examen.',
    cancelButton: "La prochaine fois",
    positiveButton: "C'est clair (%{smart_count} essai)  |||| C'est clair (%{smart_count} essais)",
    questions: "%{smart_count} question |||| %{smart_count} questions",
    oneAttempt: "Une tentative par question",
    timeLimit: "emps limité: %{limit} min",
    noPause: "TL'examen ne peut pas être mis en pause",
    progress: "Question #%{current} sur %{total}",
    closeButton: "Fermer",
    viewButton: "Voir les résultats",
    retakeButton: "Réessayer (%{smart_count} essai)  |||| Réessayer (%{smart_count} essais)",
    finishedPopupTitle: "RÉSULTAT FINAL",
    examPassed: "EXAMEN RÉUSSI",
    examNotPassed: "EXAMEN ÉCHOUÉ",
    waitHomeworks: "%{smart_count} question en cours de vérification |||| %{smart_count} questions en cours de vérification",
    result: "Votre résultat :",
  },
  subjects: {
    unavailable: "La matière est actuellement indisponible",
  },
  orderStatus: {
    approved: "Approuvé",
    canceled: "Annulé",
    pending: "En attente",
  },
  notificationsTypes: {
    event: "Événement",
    invoice: "Facture",
    news: "Actualité",
    homework: "Devoirs",
    homework_todo: "Devoirs à faire",
    type: {
      exercise: "Exercice",
      homework_todo: "Devoirs à faire",
    },
  },
  notificationsAlert: {
    subscribe: "Activer les notifications",
    unsubscribe: "Désactiver les notifications",
    instructions: "Cliquez sur le cadenas 🔒 à gauche de la barre d'adresse et modifiez les paramètres des notifications comme indiqué, ou ajustez les paramètres généraux de votre navigateur.",
    permissionDefault: {
      title: "Abonnez-vous aux notifications🔔",
      body: "Recevez des alertes sur les changements de statut des devoirs, les débuts d'événements, les actualités, et plus encore. Pas de publicité, uniquement des notifications liées à votre apprentissage!",
    },
    permissionDenied: {
      title: "Les notifications sont désactivées ❌",
      body: "Vous avez désactivé les notifications. Sans elles, vous ne serez pas informé à temps des changements d'état des devoirs ou des débuts d'événements. Pour activer les notifications de nouveau, suivez les instructions ci-dessous:",
    },
    permissionGranted: {
      title: "Les notifications sont activées ✔",
      body: "Vous pouvez les désactiver si vous ne souhaitez plus être informé des mises à jour liées à votre apprentissage. Pour désactiver les notifications, suivez les instructions ci-dessous::",
    },
  },
  feedbackDialog: {
    sendFeedback: "Envoyer un retour",
    placeholder: "Parlez-nous de vos impressions",
    defaultInstruction: "Utilisez le curseur pour évaluer",
    eventInstruction: "Évaluez le déroulement de l'événement",
    submitError: "Veuillez sélectionner une note",
    submitSuccess: "Merci pour votre retour! Votre commentaire a été envoyé avec succès",
    wasNotPresent: "Je n'ai pas participé à l'événement",
    dateOfEvent: "Date de l'événement:",
  },
  congratulation: {
    mission: "Félicitations, la mission %{name} est terminée!",
    missionTask: {
      title: "🎉 Félicitations ! La tâche %{name} est terminée.",
      content: "Il reste <b>%{need} tâches</b> pour achever la mission — continue comme ça !",
    },
  },
  accountNotFound: "Cette adresse électronique n'est pas associée à un espace d'apprentissage. Contactez l'administrateur de votre école",
  demoAccess: "Vous voulez essayer SkillzRun pour votre entreprise/école? Inscrivez-vous pour tester la plateforme",
  structure: "Structure",
  version: {
    message: "Une nouvelle version de l'application est disponible. Veuillez recharger la page pour mettre à jour",
    button: "Recharger",
  },
  missions: {
    title: "Missions",
    startButton: "Commencer la mission",
    missionStarted: "Mission commencée %{started}",
    started: "Mission lancée !",
    tasks: {
      title: "Détails de la tâche",
    },
  },
  productCatalog: {
    title: "Catalogue de produits",
    coinBalance: "Votre solde :",
    notEnoughCoins: "Pas assez de pièces",
    order: "Commander",
    orderConfirmation: "Confirmation de commande",
    price: "Prix:",
    remaining: "Reste:",
    instructionForForm: "Pour accélérer le traitement de votre commande, veuillez remplir les informations suivantes pour la réception",
    address: "Adresse",
    thankText: "Merci ! Votre commande a été enregistrée.",
    pleaseWait: "Veuillez patienter, un responsable vous contactera.",
    pleaseWaitPersona: "Veuillez attendre un SMS. Vous recevrez votre numéro de suivi.",
    thankTextOffer: "Merci ! Votre achat a été effectué.",
    contentAvailableText: "Le contenu est déjà disponible — vous pouvez l'utiliser dès maintenant.",
    deliveryAddress: "Entrez l'adresse de livraison",
    helperText: "Indiquez l'adresse complète ou la ville et le numéro de l'agence Nova Poshta/Ukrposhta.",
    deliveryOptions: "*Les options de livraison seront précisées avec le responsable après réception de la commande.",
    validationPhoneFormat: "Le numéro de téléphone doit contenir 10 chiffres et commencer par 0.",
    recipientNameLabel: "Nom complet",
    recipientNameRequired: "Veuillez saisir le nom du destinataire.",
    npCityRequired: "Veuillez sélectionner une ville de livraison.",
    npWarehouseRequired: "Veuillez sélectionner une agence Nova Poshta.",
    npCityLabel: "Ville Nova Poshta",
    npCityPlaceholder: "Commencez à saisir le nom de la ville",
    npCitySearching: "Recherche des villes...",
    npCitySelectHint: "Sélectionnez une ville dans la liste",
    npCityTypeHint: "Commencez à saisir le nom de la ville (min. 3 caractères)",
    npBranchTypeDepartments: "Agences",
    npBranchTypePostomats: "Consignes",
    npWarehouseLabel: "Agence Nova Poshta",
    npWarehousePlaceholder: "Sélectionnez une agence",
    npWarehouseLoading: "Chargement des agences...",
    npWarehouseSelectHint: "Sélectionnez une agence dans la liste",
    npWarehouseEmpty: "Aucune agence trouvée pour cette ville",
    npWarehouseCityFirst: "Sélectionnez d'abord une ville",
    inProcessing: "En cours de traitement",
    purchased: "Acheté",
    oneTimeAlreadyPurchased: "Cet article a déjà été acheté",
  },
  companyReviewTitle: "Quelle est la probabilité que vous recommandiez notre école à un ami ou une connaissance ?",
  companyReviewText: 'Évaluez sur une échelle de 1 à 10, où 1 signifie "pas du tout probable" et 10 signifie "très probable"',
  subjectReviewTitle: "À quel point avez-vous trouvé ce cours intéressant sur la plateforme ?",
  subjectReviewText: 'Évaluez sur une échelle de 1 à 10, où 1 signifie "pas du tout intéressant" et 10 signifie "très intéressant"',
  policySettings: {
    termsAndConditions: "Conditions générales",
    refund: "Politique de confidentialité",
  },
  lessonsCount_one: "%{smart_count} leçon",
  lessonsCount_few: "%{smart_count} leçons",
  lessonsCount_many: "%{smart_count} leçons",
  promoCode: "Code promotionnel",
  promoInvalid: "Le code promotionnel n'est pas valide",
};
